













import Vue from 'vue';
import moment from 'moment';
import QueueForm from '@/components/Forms/QueueForm.vue';

export default Vue.extend({
  name: 'webview',
  components: {
    QueueForm,
  },
  computed: {},
});
